// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_3d_5Z3_cLfYrHBQiRM4I-_","spaceLeft":"GjjwyK9n0e7kyYRQ9Gh-j","spaceBoth":"_2Csu7wScmUfAKtqzR9Oge6","spaceRight":"_3oGJwjOoImaX2FzPnAfokQ","ClosingTime":"_1Xv34eEyUlaZvada5Cdmz7","Date":"_2qVZyAhf1ENkEe9t7xzfN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisExpirationDate.scss
// module id = 1046
// module chunks = 0